import React, { Component } from 'react';
import './VideoInstruction.css';

class VideoInstruction extends Component {
    render() {
        return (
            <div className="VideoInstruction">
                <video
                    src={`/instructions_vids/instruction_step_${this.props.VIDEO_INSTRUCTION_ID}.mp4`}
                    height="80px"
                    autoPlay muted loop></video>
            </div>

        );
    }
}


export default VideoInstruction;